export enum EducationalCategory {
  Schools = "Schools",
  HigherEducations = "HigherEducations",
  Disabilities = "Disabilities",
}
